import {Component, OnInit} from '@angular/core';
import {AppConstant} from "../../../shared/utility/app-constant";
import {Router} from "@angular/router";
import {DashboardService} from "../../../shared/services/dashboard/dashboard.service";


@Component({
  selector: 'app-access-revoked',
  templateUrl: './access-revoked.component.html',
  styleUrls: ['./access-revoked.component.scss']
})
export class AccessRevokedComponent implements OnInit{

  constructor(private router: Router, public dashboardService: DashboardService) {
  }

  ngOnInit() {

  }


  returnToMyProfile(){
    this.router.navigate(['/home/dashboard']).then(() => {
      window.location.reload();
    });
  }
}
